<template>
    <v-layout>
        <v-flex xs12 sm12 md12>
            <v-card>
                <v-card-title primary-title>
                    <div>
                        <h3 class="headline mb-0">AVISO A TODA LA POBLACIÓN ESTUDIANTIL</h3>
                        <div>
                            SE HACE DEL CONOCIMIENTO A TODO EL ALUMNADO DE ESTE INSTITUTO TECNOLÓGICO DE TUXTLA GUTIÉRREZ,
                            PERTENECIENTE AL TECNOLÓGICO NACIONAL DE MÉXICO DE LA SECRETARÍA DE EDUCACIÓN PÚBLICA, ...
                        </div>
                    </div>
                </v-card-title>

                <v-card-actions>
                    <v-btn flat color="orange" @click="showDialog = true">Continuar leyendo</v-btn>
                </v-card-actions>
            </v-card>
            <v-dialog v-model="showDialog" max-width="580" scrollable>
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">AVISO A TODA LA POBLACIÓN ESTUDIANTIL</h3>
                        </div>
                    </v-card-title>
                    <v-card-text style="height: 500px">
                        <p style="color: black;">
                            SE HACE DEL CONOCIMIENTO A TODO EL ALUMNADO DE ESTE INSTITUTO TECNOLÓGICO DE TUXTLA GUTIÉRREZ,
                            PERTENECIENTE AL TECNOLÓGICO NACIONAL DE MÉXICO DE LA SECRETARÍA DE EDUCACIÓN PÚBLICA, QUE DE CONFORMIDAD CON LO DISPUESTO POR LOS ARTÍCULOS:
                            <br><b>194 inciso e), 201 inciso a), 250, 252 inciso a), numerales 4 y 5, 253 incisos b) y f), numerales 1 y 2, 254 incisos b) y c), numerales 1 y 2, 257 y 258, </b>
                            <br>TODOS DEL <b>REGLAMENTO DE LOS ALUMNOS DEL SISTEMA NACIONAL DE INSTITUTOS TECNOLÓGICOS (ACTUALMENTE TECNOLÓGICO NACIONAL DE MÉXICO DE LA SECRETARÍA DE EDUCACIÓN PÚBLICA) </b>,
                            <br>EN LOS CUALES SE DISPONE LO SIGUIENTE:
                            <br>
                            <br>
                            <b>ARTÍCULO 194.-</b> Son derechos de los alumnos de Institutos Tecnológicos:
                            <br>
                            <br>
                            e) Recibir, si así lo solicita, orientación en sus problemas académicos y personales.
                            <br>
                            <b>ARTÍCULO 201.-</b> Son obligaciones de los alumnos de los Institutos Tecnológicos:
                            <br>
                            <br>
                            a) Acatar las disposiciones de los manuales de procedimientos, normatividad y reglamentos internos establecidos por la Dirección General de Institutos Tecnológicos. (Hoy Tecnológico Nacional de México de la Secretaría de Educación Pública).
                            <br>
                            <b>ARTÍCULO 250.-</b> Toda violación de los preceptos de éste reglamento, será motivo de una sanción que corresponderá a la gravedad de la falta, ya sea ésta de carácter individual o colectiva.
                            <br>
                            <b>ARTÍCULO 252.-</b> si los alumnos incurren en las faltas siguientes:
                            <br>
                            a) El procedimiento <b>fraudulento</b> dentro de las <b>evaluaciones</b> de cualquier tipo.
                            <br>
                            <br>
                            4. <b>Suspensión</b> de los derechos estudiantiles hasta <b>por una semana</b> con anotación en el expediente del alumno y aviso al padre o tutor.
                            <br>
                            5. <b>Suspensión definitiva</b> de la asignatura conservando el alumno solamente el derecho a presentar examen especial.
                            <br>
                            <b>ARTÍCULO 253.-</b> Si los <b>alumnos incurren</b> en las faltas siguientes:
                            <br>
                            b) Los actos <b>contrarios a la moral.</b>
                            <br>
                            <br>
                            f) Las que lesionen el <b>buen nombre</b> de la institución.
                            <br>
                            1. <b>Suspensión</b> de derechos estudiantiles hasta por <b>15 días</b> con anotación en el expediente del alumno y aviso al padre o tutor.
                            <br>
                            2. <b>Suspensión</b> de derechos estudiantiles hasta <b>por un semestre.</b>
                            <br>
                            <b>ARTÍCULO 254.-</b> Si los <b>alumnos incurren</b> en las siguientes faltas:
                            <br>
                            <br>
                            b) La <b>alteración, falsificación o sustracción</b> no autorizada de documentos oficiales.
                            <br>
                            c) La realización de <b>actos que atenten contra</b> las actividades docentes y/o administrativas.
                            <br>
                            1. <b>Baja definitiva del Instituto Tecnológico.</b>
                            <br>
                            2. <b>Baja definitiva del Sistema Nacional de Institutos Tecnológicos (Hoy Tecnológico Nacional de México de la Secretaría de Educación Pública). </b>
                            <br>
                            <b>ARTÍCULO 257.-</b> Cuando fuera de la institución el alumno incurra en <b>actos que menoscabe</b> el prestigio de la institución, queda a discreción de la Dirección General de Institutos Tecnológicos*, aplicar la sanción correspondiente conforme a lo previsto por este reglamento. *(Hoy Tecnológico Nacional de México de la Secretaría de Educación Pública).
                            <br>
                            <b>ARTÍCULO 258.-</b> En casos de faltas o delitos que ocurran dentro del instituto y que caigan bajo la <b>sanción de los códigos civiles y o penales</b>, la dirección del plantel levantara las actas correspondientes y las turnara a las autoridades competentes, independientemente de la imposición de la sanción reglamentaria que corresponda.
                            <br>
                            <br>
                            SE LES HACE DE SU CONOCIMIENTO Y SE LES CONMINA PARA QUE SU CONDUCTA, DENTRO Y FUERA DE LAS INSTALACIONES DE ESTE INSTITUTO TECNOLÓGICO, SEA RECTA E INTACHABLE Y DE CONFORMIDAD CON LOS PRECEPTOS LEGALES ANTES REFERIDOS, NO SE HAGAN ACREDORES A NINGUNA APLICACIÓN DISCIPLINARIA.
                            <br>
                            NO SE OMITE MANIFESTAR QUE LAS DISPOSICIONES LEGALES ANTES REFERIDAS, HAN SIDO HECHAS DEL CONOCIMINTO DE USTEDES DESDE SU INGRESO A ESTA H. INSTITUCIÓN DE EDUCACIÓN SUPERIOR TECNOLÓGICA.
                            <br>
                            <br>
                            <br>
                            ATENTAMENTE
                            <br>
                            <br>
                            INSTITUTO TECNOLÓGICO DE TUXTLA GUTIÉRREZ
                        </p>
                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat color="orange" @click="showDialog = false">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
  export default {
    name: 'AvisoEstudiantes',
    data: () => ({
      showDialog: false
    })
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/AvisoEstudiantes.vue